// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__W-7ln","header":"ReportDetails_header__3iA0f","title":"ReportDetails_title__kl10-","left":"ReportDetails_left__12396"};